import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, Renderer2, OnChanges } from '@angular/core';
import { DevicesDashboardService } from '../../../devices/devices-dashboard.service';
import { UserService } from '../../../../../auth/user.service';
import { CommonUtil } from '../../../../../shared/services/utility/common.service';
import { TruckviewsDashboardService } from '../truckviews-dashboard.service';

import { NotificationMessageService } from '../../../../../shared/notification-message/notification-message.service';
import { CommonDataService } from '../../../../../shared/services/common-data.service';

@Component({
	selector: 'app-truckview-settings',
	templateUrl: './truckview-settings.component.html',
	styleUrls: ['./truckview-settings.component.css']
})
export class TruckviewSettingsComponent implements OnInit, OnChanges {

	@Input() customerID: number = 0;
	@Input() siteID: number = 0;
	@Input() truckviewsIDs: any = [];
	@Input() hasTruckviews = false;
	@Input() isTruckviewMobile: boolean = false;
	truckview: any = {};
	currentUser: any = {};
	changesStack: any = {};
	oldTruckview: any = {};
	userAccess: any = {};
	isBulk: boolean = false;
	originalTruckviewsInfo: any = [];
	TRCurrentRates: any[]			= [];
	CCCurrentRates: any[]			= [];
	FICurrentRates: any[]			= [];
	EQCurrentRates: any[]			= [];
	TemperatureFallbackOpts: any[]	= [];
	blockedDaysOpts: any[]			= [];
	daysOfTheWeek: any[]			= [];
	finishDt: any[]					= [];
	cableGaugeOptions: any[]		= [];
	PMinputVoltages: any[]			= [];
	pmVoltages: any[]				= [];
	truckTypes: any[]				= [];
	chargerTypes: any[]				= [];
	cvCurrentSteps: any[]			= [];
	cvFinishCurrents: any[]			= [];
	finishDvVoltages: any[]			= [];
	truckVoltages: any[]			= [];
	timeIntervals: any[]			= [];
	quartsIntervals: any[]			= [];
	quarts_2_18: any[]				= [];
	quarts_6_18: any[]				= [];
	quarts_2_6: any[]				= [];
	quarts_1_6: any[]				= [];
	hours_1_5: any[]				= [];
	quarts_2_24: any[]				= [];
	limitingFactors: any[]			= [];
	resistancePerFoot: any			= {};
	dirtyFields: any				= {};
	temperatureFields: any = {
		'cooldowntemperature': '',
		'foldtemperature': '',
		'trtemperature': '',
		'truckhightemperature': ''
	};
	formatTemperature: string = '';
	formName: string = '';
	tab: string = 'CARDS';
	stage: string = '';

	@Output() onMultipleOptionsFlag = new EventEmitter<boolean>();
	@Output() onGetTruckviewInfo = new EventEmitter<object>();
	@Output() updateAppearanceElementsFlags = new EventEmitter<any>(true);

	@ViewChild("saveOptionsModal") saveOptionsModal;
	@ViewChild("chargerProfileModal") chargerProfileModal;

	constructor(
		private devicesDashboard: DevicesDashboardService,
		private truckviewsDashboard: TruckviewsDashboardService,
		private notificationMessage: NotificationMessageService,
		public commonData: CommonDataService,
		public userService: UserService,
		// private truckviewService: TruckviewService,
		private elementRef: ElementRef,
		private renderer: Renderer2,
		private commonUtil: CommonUtil,
	) {
		devicesDashboard.settingsDeviceType = "TRUCKVIEW";
	}

	ngOnInit() {
		
		this.updateAppearanceElementsFlags.emit({
			addNoteEnabled: false,
			pageHasFilterByDate: false,
			pageHasTruckviewTags: true,
			hasResetPLC: false,
			pageHasManageBtn: true,
			pageHasTimesInfo: true,
		});

		this.currentUser = this.userService.getCurrentUser();
		this.userAccess = this.currentUser.userAccess;

		if(this.truckviewsIDs.length > 1) {
			this.hasTruckviews = true;

			if(!this.isTruckviewMobile)
				this.isBulk = true;
		}

		this.devicesDashboard.isBulkSettings = this.isBulk;

		this.finishDt				= this.commonUtil.getDropDownListData('number', {start:10, end:59, step:1});
		this.truckTypes			= this.devicesDashboard.truckTypes;
		this.chargerTypes			= this.devicesDashboard.chargerTypes;
		this.daysOfTheWeek			= this.commonUtil.getDropDownListData('week');
		let blockedDaysOpts: any	= [5, 6, 7, 8, 9];
		blockedDaysOpts				= this.commonUtil.arrayToArrayOfObjects(blockedDaysOpts, blockedDaysOpts);
		blockedDaysOpts.unshift({'id': 0, 'name': 'Disable'});
		this.blockedDaysOpts = blockedDaysOpts;
		this.TemperatureFallbackOpts	= this.truckviewsDashboard.TemperatureFallbackOptions;

		let cvCurrentSteps			= this.commonUtil.getDropDownListData('number', {start:2, end:10, step:0.5});
		cvCurrentSteps.unshift(0);
		let cvCurrentStepsValues	= cvCurrentSteps.slice();
		cvCurrentStepsValues[0]		= 'Default';
		this.cvCurrentSteps			= this.commonUtil.arrayToArrayOfObjects(cvCurrentSteps, cvCurrentStepsValues);

		this.TRCurrentRates		= this.devicesDashboard.TRCurrentRates;
		this.CCCurrentRates		= this.devicesDashboard.CCCurrentRates;
		this.FICurrentRates		= this.devicesDashboard.FICurrentRates;
		this.EQCurrentRates		= this.devicesDashboard.EQCurrentRates;
		this.cvFinishCurrents	= this.devicesDashboard.cvFinishCurrents;
		this.finishDvVoltages	= this.devicesDashboard.finishDvVoltages;
		let truckVoltages		= this.commonUtil.getDropDownListData('number', {'start': 24, 'end': 48, 'step': 2});
		truckVoltages.push(72, 80);
		this.truckVoltages = truckVoltages;

		this.timeIntervals		= this.devicesDashboard.timeIntervals;
		this.quartsIntervals	= this.devicesDashboard.quartsIntervals;
		this.quarts_2_18		= this.devicesDashboard.quarts_2_18;
		this.quarts_6_18		= this.devicesDashboard.quarts_6_18;
		this.quarts_2_6			= this.devicesDashboard.quarts_2_6;
		this.quarts_1_6			= this.devicesDashboard.quarts_1_6;
		this.limitingFactors	= this.devicesDashboard.limitingFactors;
		this.hours_1_5			= this.commonUtil.getDropDownListData('clock',  {start:1, end:5, step:60});
		this.quarts_2_24		= this.commonUtil.getDropDownListData('clock',  {start:2, end:24, step:15, ignoreFirst: 2});
	}

	ngOnChanges(changes: any) {
		if(changes.truckviewsIDs && changes.truckviewsIDs.currentValue && changes.truckviewsIDs.currentValue.length > 0)
			this.getTruckviewsSettingsInfo();
	}

	setTab(tabId){
		this.tab = tabId;
	};

	isSet(tabId){
		return this.tab === tabId;
	};

	resetForms(removeErrors = false) {
		if(this.truckviewsIDs.length > 0 && !removeErrors) {
			this.truckview = Object.assign({}, this.oldTruckview);
		}
		
		if(this.truckviewsIDs.length > 0 || removeErrors) {
			let invalidInputs = this.elementRef.nativeElement.querySelectorAll('.invalid-input');
			invalidInputs.forEach((item) => {
				item.classList.remove('invalid-input');
			});
		}

		this.dirtyFields = {};
	}

	getTruckviewsSettingsInfo() {
		if(this.truckviewsIDs.length === 0)
			return;

		this.truckviewsDashboard.getTruckviewsSettingsInfo(this.truckviewsIDs).subscribe(
			(truckviews: any) => {

				this.originalTruckviewsInfo = truckviews.settings.map(x => Object.assign({}, x));

				if(this.isBulk) {
					this.formatTemperature = 'F';
					truckviews.settings.forEach((aTruckview) => {
						for(var field in this.temperatureFields) { //In case of bulk: Always show temperature fields in F format
							aTruckview[field] = this.commonUtil.fahToCel(aTruckview[field], true);
						}
					});
				}

				if(this.isBulk) {
					truckviews.settings = this.commonUtil.getArrayOfObjectsIntersection(truckviews.settings);
				} else {
					truckviews.settings = truckviews.settings[0];
					truckviews.settings.wifi_at_version = this.commonUtil.Format_WIFI_AT_Version(truckviews.settings.wifi_at_version);
				}

				if(truckviews.settings.currentclamp2cala > 0)
					truckviews.settings.halleffectreverse = false;
				else
					truckviews.settings.halleffectreverse = true;

				if(truckviews.settings.installationdate !== null)
					truckviews.settings.installationdate = new Date(truckviews.settings.installationdate);

				if(truckviews.settings.manufacturingdateview !== null)
					truckviews.settings.manufacturingdateview = new Date(truckviews.settings.manufacturingdateview);

				this.oldTruckview = Object.assign({}, truckviews.settings);

				this.truckview = truckviews.settings;

				this.changesStack = this.truckviewsDashboard.formatTruckviewQueuedChanges(this.truckview, truckviews.changesStack);

				for(var field in this.temperatureFields) { //save original temperature fields value
					this.temperatureFields[field] = this.truckview[field];
				}
	
				this.truckview.lastuploadtime	= new Date(this.truckview.lastuploadtime);
				this.truckview.lasteventtime		= new Date(this.truckview.lasteventtime);

				if(!this.isBulk) {
					this.formatTemperature = 'C';
					if(Object.keys(this.truckview).length > 0) {
						if(this.truckview.temperatureformat) {

							this.formatTemperature = 'F';
							for(let field in this.temperatureFields) { //temperatureformat is F so; convert C -> F
								this.oldTruckview[field]	= this.commonUtil.fahToCel(this.truckview[field], true);
								this.truckview[field]	= this.commonUtil.fahToCel(this.truckview[field], true);
							}
						}
					}

					let multipleOptions: boolean = false;
						
					if((this.userService.hasAccessFunction('act_admin_device_management') && this.truckview.enableplc)
						|| (this.currentUser.isACTuser && this.truckview.time_gap > 0) || this.userService.hasAccessFunction('restart_devices')
						|| (this.userService.hasAccessFunction('remote_truckview_calibration') && !this.truckview.isCalibrated && this.truckview.actviewenabled && this.truckview.enableplc && this.truckview.firmwareversion >= 2.12)
					) {
						multipleOptions = true;
					}

					this.onMultipleOptionsFlag.emit(multipleOptions);
					this.onGetTruckviewInfo.emit(this.truckview);
				}
			}
		);
	}

	saveTruckviewSettings() {

		if(this.oldTruckview.actviewenabled === null && this.stage == 'queue') {

			var errorMessage = "ACT intelligent option is not enabled for the following TRUCKViews:<br/>";
			var notActviewenabledTruckviews = [];
			this.originalTruckviewsInfo.forEach((truckviewTemp) => {
				if(truckviewTemp.actviewenabled == false)
					notActviewenabledTruckviews.push(truckviewTemp.truckid + ' (' + truckviewTemp.serialnumber + ')');
			});
			
			errorMessage += notActviewenabledTruckviews.join('<br/>');
			this.notificationMessage.setMessage(errorMessage, 'danger', 30000);

		} else {

			let dirtyFields = this.truckviewsDashboard.truckviewUpdatedFieldsEffect(this.dirtyFields, this.oldTruckview);

			dirtyFields.ids					= this.truckviewsIDs;
            dirtyFields.isTruckviewMobile	= this.isTruckviewMobile;
			dirtyFields.studyid				= this.truckview.studyid || 0;
			this.truckviewsDashboard.saveTruckviewSettings(this.stage, dirtyFields).subscribe((response: any) => {
				if(response.httpStatus == 'error') {
					if(response.type == 'invalidFields') {

						this.highlightInvalidFields(response.data);
					} else if(response.type == 'info') {

						var errorMessage = "An error occurred while trying to apply changes for the following TRUCKViews:<br/>";
						var faultedTruckviews = response.data.join('<br/>');
						errorMessage += faultedTruckviews;
						this.notificationMessage.setMessage(errorMessage, 'danger', 30000);
					}
				} else {
					
					this.getTruckviewsSettingsInfo();
				}
			});
		}
	};

	getStackHTML(field) {
		var stack = this.changesStack;

		if(!stack || !stack[field])
			return "";

		var returnHTML = `
				<p class='stackHTML'>
					<strong class='tcenter'>Changes Stack</strong>
				</p>
				<table class='stackHTML-table'>
					<tr><th>Value</th><th>User Name</th></tr>`;

		stack[field].forEach((item) => {
			returnHTML += "<tr><td style='color: white'>" + item[0] + "</td><td>" + item[1] + "</td></tr>";
		});
		
		returnHTML += "</table>";

		return returnHTML;
	}

	deselectAllDays(field) {
		if(this.truckview) {
			this.truckview[field] = [];
		}
	}

	setManufacturingDate() {
		if(this.truckview) {
			if(this.truckview.manufacturingdatesameasinstallation)
				this.truckview.manufacturingdateview = new Date(this.truckview.installationdate);
		}
	};

	checkChanges(formName) {

		let freshTruckview = this.truckview;
		let dirtyFields = {};
		let oldTruckview = this.oldTruckview;
		this.formName = formName;

		this.resetForms(true);

		let arrayFields		= ['fidaysmask', 'eqdaysmask'];
		let ignoredFields	= ['lastuploadtime', 'lasteventtime'];

		for (let key in oldTruckview) {
			
			if(ignoredFields.indexOf(key) != -1)
				continue;

			if(arrayFields.indexOf(key) != -1) {

				if(oldTruckview[key] && freshTruckview[key] && !this.commonUtil.arrayCompare(oldTruckview[key], freshTruckview[key])) {
					dirtyFields[key] = freshTruckview[key];
				}
			} else if(oldTruckview[key] != freshTruckview[key]) {
			
				dirtyFields[key] = freshTruckview[key];
			}
		}

		if(Object.keys(dirtyFields).length > 0) {

			for(let fieldName in dirtyFields) {

				if(this.temperatureFields.hasOwnProperty(fieldName)) {
					if(this.truckview.temperatureformat) {

						for(let field in this.temperatureFields) {
							dirtyFields[field] = this.commonUtil.fahToCel(this.truckview[field]);
						}
					} else {

						dirtyFields[fieldName] = this.truckview[fieldName];
					}
				} else {
					if(fieldName == 'installationdate' || fieldName == 'manufacturingdateview')
						dirtyFields[fieldName] = Math.floor(new Date(new Date(-this.truckview[fieldName].getTimezoneOffset() * 60000 + this.truckview[fieldName].getTime())).getTime() / 1000);
					else
						dirtyFields[fieldName] = this.truckview[fieldName];
				}
			}

			let invalidFields = []; /*this.truckviewService.validateTruckviewSettings(dirtyFields, this.isBulk, oldTruckview, this.originalTruckviewsInfo);*/
			this.dirtyFields = dirtyFields;
			
			if(invalidFields.length > 0) {
				this.highlightInvalidFields(invalidFields);
			} else {

				if(this.userService.hasAccessFunction('act_admin_device_management')
					&& (oldTruckview.actviewenabled || oldTruckview.actviewenabled === null)) {
					this.saveOptionsModal.show();
				} else {
					this.userSaveOption();
				}
			}
		}
	}

	updateWarrantedAhr() {
		if(this.truckview && this.truckview.ahrcapacity) {
			this.truckview.warrantedahr = this.truckview.ahrcapacity * 1250;
		}
	}

	highlightInvalidFields(invalidFields) {
		let forms = this.elementRef.nativeElement.querySelectorAll('form');
				
		forms.forEach((form) => {
			
			if(form.getAttribute('name') == this.formName) {
				for(let idx in form) {
					let ele = form[idx];
					if(Number.isInteger(Number(idx))) {
						if(invalidFields.indexOf(ele.getAttribute('name')) != -1)
							this.renderer.addClass(ele, 'invalid-input');
					}
				}
			}
		});
		this.notificationMessage.setMessage('Invalid input!');
	}

	userSaveOption = function(stage = 'queue') {

		this.stage = stage;

		if(!this.dirtyFields.hasOwnProperty('chargertype') && !this.dirtyFields.hasOwnProperty('trucktype'))
			return this.saveTruckviewSettings();

		this.chargerProfileModal.show();
	}
}